var map = {
	"./chat/embedded/banking_finance/120x28/pageData": 572,
	"./chat/embedded/banking_finance/120x28/pageData.json": 572,
	"./chat/embedded/banking_finance/171x88/pageData": 573,
	"./chat/embedded/banking_finance/171x88/pageData.json": 573,
	"./chat/embedded/banking_finance/221x86/pageData": 574,
	"./chat/embedded/banking_finance/221x86/pageData.json": 574,
	"./chat/embedded/ecommerce/120x28/pageData": 575,
	"./chat/embedded/ecommerce/120x28/pageData.json": 575,
	"./chat/embedded/ecommerce/171x88/pageData": 576,
	"./chat/embedded/ecommerce/171x88/pageData.json": 576,
	"./chat/embedded/ecommerce/221x86/pageData": 577,
	"./chat/embedded/ecommerce/221x86/pageData.json": 577,
	"./chat/embedded/education/120x28/pageData": 578,
	"./chat/embedded/education/120x28/pageData.json": 578,
	"./chat/embedded/education/171x88/pageData": 579,
	"./chat/embedded/education/171x88/pageData.json": 579,
	"./chat/embedded/education/221x86/pageData": 580,
	"./chat/embedded/education/221x86/pageData.json": 580,
	"./chat/embedded/gaming/120x28/pageData": 581,
	"./chat/embedded/gaming/120x28/pageData.json": 581,
	"./chat/embedded/gaming/171x88/pageData": 582,
	"./chat/embedded/gaming/171x88/pageData.json": 582,
	"./chat/embedded/gaming/221x86/pageData": 583,
	"./chat/embedded/gaming/221x86/pageData.json": 583,
	"./chat/embedded/general/120x28/pageData": 584,
	"./chat/embedded/general/120x28/pageData.json": 584,
	"./chat/embedded/general/171x88/pageData": 585,
	"./chat/embedded/general/171x88/pageData.json": 585,
	"./chat/embedded/general/221x86/pageData": 586,
	"./chat/embedded/general/221x86/pageData.json": 586,
	"./chat/embedded/health/120x28/pageData": 587,
	"./chat/embedded/health/120x28/pageData.json": 587,
	"./chat/embedded/health/171x88/pageData": 588,
	"./chat/embedded/health/171x88/pageData.json": 588,
	"./chat/embedded/health/221x86/pageData": 589,
	"./chat/embedded/health/221x86/pageData.json": 589,
	"./chat/embedded/tech_software/120x28/pageData": 590,
	"./chat/embedded/tech_software/120x28/pageData.json": 590,
	"./chat/embedded/tech_software/171x88/pageData": 591,
	"./chat/embedded/tech_software/171x88/pageData.json": 591,
	"./chat/embedded/tech_software/221x86/pageData": 592,
	"./chat/embedded/tech_software/221x86/pageData.json": 592,
	"./chat/embedded/travel/120x28/pageData": 593,
	"./chat/embedded/travel/120x28/pageData.json": 593,
	"./chat/embedded/travel/171x88/pageData": 594,
	"./chat/embedded/travel/171x88/pageData.json": 594,
	"./chat/embedded/travel/221x86/pageData": 595,
	"./chat/embedded/travel/221x86/pageData.json": 595,
	"./chat/overlay/custoddm/440x305px/pageData": 596,
	"./chat/overlay/custoddm/440x305px/pageData.json": 596,
	"./chat/overlay/general/206x290/pageData": 597,
	"./chat/overlay/general/206x290/pageData.json": 597,
	"./chat/overlay/general/300x200px/pageData": 598,
	"./chat/overlay/general/300x200px/pageData.json": 598,
	"./chat/overlay/general/360x240/pageData": 599,
	"./chat/overlay/general/360x240/pageData.json": 599,
	"./chat/overlay/general/440x305px/pageData": 600,
	"./chat/overlay/general/440x305px/pageData.json": 600,
	"./chat/peeling-corner/general/350x350px/pageData": 601,
	"./chat/peeling-corner/general/350x350px/pageData.json": 601,
	"./chat/peeling-corner/general/550x550px/pageData": 602,
	"./chat/peeling-corner/general/550x550px/pageData.json": 602,
	"./chat/slider/general/300x200px/pageData": 603,
	"./chat/slider/general/300x200px/pageData.json": 603,
	"./chat/slider/general/440x305px/pageData": 604,
	"./chat/slider/general/440x305px/pageData.json": 604,
	"./chat/sticky/banking_finance/120x28/pageData": 605,
	"./chat/sticky/banking_finance/120x28/pageData.json": 605,
	"./chat/sticky/banking_finance/171x88/pageData": 606,
	"./chat/sticky/banking_finance/171x88/pageData.json": 606,
	"./chat/sticky/banking_finance/221x86/pageData": 607,
	"./chat/sticky/banking_finance/221x86/pageData.json": 607,
	"./chat/sticky/ecommerce/120x28/pageData": 608,
	"./chat/sticky/ecommerce/120x28/pageData.json": 608,
	"./chat/sticky/ecommerce/171x88/pageData": 609,
	"./chat/sticky/ecommerce/171x88/pageData.json": 609,
	"./chat/sticky/ecommerce/221x86/pageData": 610,
	"./chat/sticky/ecommerce/221x86/pageData.json": 610,
	"./chat/sticky/education/120x28/pageData": 611,
	"./chat/sticky/education/120x28/pageData.json": 611,
	"./chat/sticky/education/171x88/pageData": 612,
	"./chat/sticky/education/171x88/pageData.json": 612,
	"./chat/sticky/education/221x86/pageData": 613,
	"./chat/sticky/education/221x86/pageData.json": 613,
	"./chat/sticky/gaming/120x28/pageData": 614,
	"./chat/sticky/gaming/120x28/pageData.json": 614,
	"./chat/sticky/gaming/171x88/pageData": 615,
	"./chat/sticky/gaming/171x88/pageData.json": 615,
	"./chat/sticky/gaming/221x86/pageData": 616,
	"./chat/sticky/gaming/221x86/pageData.json": 616,
	"./chat/sticky/general/120x28/pageData": 617,
	"./chat/sticky/general/120x28/pageData.json": 617,
	"./chat/sticky/general/171x88/pageData": 618,
	"./chat/sticky/general/171x88/pageData.json": 618,
	"./chat/sticky/general/221x86/pageData": 619,
	"./chat/sticky/general/221x86/pageData.json": 619,
	"./chat/sticky/health/120x28/pageData": 620,
	"./chat/sticky/health/120x28/pageData.json": 620,
	"./chat/sticky/health/171x88/pageData": 621,
	"./chat/sticky/health/171x88/pageData.json": 621,
	"./chat/sticky/health/221x86/pageData": 622,
	"./chat/sticky/health/221x86/pageData.json": 622,
	"./chat/sticky/tech_software/120x28/pageData": 623,
	"./chat/sticky/tech_software/120x28/pageData.json": 623,
	"./chat/sticky/tech_software/171x88/pageData": 624,
	"./chat/sticky/tech_software/171x88/pageData.json": 624,
	"./chat/sticky/tech_software/221x86/pageData": 625,
	"./chat/sticky/tech_software/221x86/pageData.json": 625,
	"./chat/sticky/travel/120x28/pageData": 626,
	"./chat/sticky/travel/120x28/pageData.json": 626,
	"./chat/sticky/travel/171x88/pageData": 627,
	"./chat/sticky/travel/171x88/pageData.json": 627,
	"./chat/sticky/travel/221x86/pageData": 628,
	"./chat/sticky/travel/221x86/pageData.json": 628,
	"./chat/toaster/general/140px/pageData": 629,
	"./chat/toaster/general/140px/pageData.json": 629,
	"./chat/toaster/general/50px/pageData": 630,
	"./chat/toaster/general/50px/pageData.json": 630,
	"./content/embedded/general/120x28/pageData": 631,
	"./content/embedded/general/120x28/pageData.json": 631,
	"./content/embedded/general/171x88/pageData": 632,
	"./content/embedded/general/171x88/pageData.json": 632,
	"./content/embedded/general/221x86/pageData": 633,
	"./content/embedded/general/221x86/pageData.json": 633,
	"./content/overlay/discounts/300x200px/pageData": 634,
	"./content/overlay/discounts/300x200px/pageData.json": 634,
	"./content/overlay/discounts/440x305px/pageData": 635,
	"./content/overlay/discounts/440x305px/pageData.json": 635,
	"./content/overlay/holiday_special/300x200px/pageData": 636,
	"./content/overlay/holiday_special/300x200px/pageData.json": 636,
	"./content/overlay/holiday_special/440x305px/pageData": 637,
	"./content/overlay/holiday_special/440x305px/pageData.json": 637,
	"./content/overlay/promotion/300x200px/pageData": 638,
	"./content/overlay/promotion/300x200px/pageData.json": 638,
	"./content/overlay/promotion/440x305px/pageData": 639,
	"./content/overlay/promotion/440x305px/pageData.json": 639,
	"./content/overlay/sales/300x200px/pageData": 640,
	"./content/overlay/sales/300x200px/pageData.json": 640,
	"./content/overlay/sales/440x305px/pageData": 641,
	"./content/overlay/sales/440x305px/pageData.json": 641,
	"./content/overlay/seasons/300x200px/pageData": 642,
	"./content/overlay/seasons/300x200px/pageData.json": 642,
	"./content/overlay/seasons/440x305px/pageData": 643,
	"./content/overlay/seasons/440x305px/pageData.json": 643,
	"./content/overlay/support_services/300x200px/pageData": 644,
	"./content/overlay/support_services/300x200px/pageData.json": 644,
	"./content/overlay/support_services/440x305px/pageData": 645,
	"./content/overlay/support_services/440x305px/pageData.json": 645,
	"./content/overlay/travel/300x200px/pageData": 646,
	"./content/overlay/travel/300x200px/pageData.json": 646,
	"./content/overlay/travel/440x305px/pageData": 647,
	"./content/overlay/travel/440x305px/pageData.json": 647,
	"./content/peeling-corner/Business use cases/350x350px/pageData": 648,
	"./content/peeling-corner/Business use cases/350x350px/pageData.json": 648,
	"./content/peeling-corner/Business use cases/550x550px/pageData": 649,
	"./content/peeling-corner/Business use cases/550x550px/pageData.json": 649,
	"./content/peeling-corner/discounts/350x350px/pageData": 650,
	"./content/peeling-corner/discounts/350x350px/pageData.json": 650,
	"./content/peeling-corner/discounts/550x550px/pageData": 651,
	"./content/peeling-corner/discounts/550x550px/pageData.json": 651,
	"./content/peeling-corner/promotion/350x350px/pageData": 652,
	"./content/peeling-corner/promotion/350x350px/pageData.json": 652,
	"./content/peeling-corner/promotion/550x550px/pageData": 653,
	"./content/peeling-corner/promotion/550x550px/pageData.json": 653,
	"./content/peeling-corner/sales/350x350px/pageData": 654,
	"./content/peeling-corner/sales/350x350px/pageData.json": 654,
	"./content/peeling-corner/sales/550x550px/pageData": 655,
	"./content/peeling-corner/sales/550x550px/pageData.json": 655,
	"./content/peeling-corner/seasons/350x350px/pageData": 656,
	"./content/peeling-corner/seasons/350x350px/pageData.json": 656,
	"./content/peeling-corner/seasons/550x550px/pageData": 657,
	"./content/peeling-corner/seasons/550x550px/pageData.json": 657,
	"./content/peeling-corner/support_services/350x350px/pageData": 658,
	"./content/peeling-corner/support_services/350x350px/pageData.json": 658,
	"./content/peeling-corner/support_services/550x550px/pageData": 659,
	"./content/peeling-corner/support_services/550x550px/pageData.json": 659,
	"./content/peeling-corner/travel/350x350px/pageData": 660,
	"./content/peeling-corner/travel/350x350px/pageData.json": 660,
	"./content/peeling-corner/travel/550x550px/pageData": 661,
	"./content/peeling-corner/travel/550x550px/pageData.json": 661,
	"./content/slider/promotion/300x200px/pageData": 662,
	"./content/slider/promotion/300x200px/pageData.json": 662,
	"./content/slider/promotion/440x305px/pageData": 663,
	"./content/slider/promotion/440x305px/pageData.json": 663,
	"./content/slider/sales/300x200px/pageData": 664,
	"./content/slider/sales/300x200px/pageData.json": 664,
	"./content/slider/sales/440x305px/pageData": 665,
	"./content/slider/sales/440x305px/pageData.json": 665,
	"./content/slider/seasons/300x200px/pageData": 666,
	"./content/slider/seasons/300x200px/pageData.json": 666,
	"./content/slider/seasons/440x305px/pageData": 667,
	"./content/slider/seasons/440x305px/pageData.json": 667,
	"./content/slider/support_services/300x200px/pageData": 668,
	"./content/slider/support_services/300x200px/pageData.json": 668,
	"./content/slider/support_services/440x305px/pageData": 669,
	"./content/slider/support_services/440x305px/pageData.json": 669,
	"./content/slider/travel/300x200px/pageData": 670,
	"./content/slider/travel/300x200px/pageData.json": 670,
	"./content/slider/travel/440x305px/pageData": 671,
	"./content/slider/travel/440x305px/pageData.json": 671,
	"./content/sticky/general/120x28/pageData": 672,
	"./content/sticky/general/120x28/pageData.json": 672,
	"./content/sticky/general/171x88/pageData": 673,
	"./content/sticky/general/171x88/pageData.json": 673,
	"./content/sticky/general/221x86/pageData": 674,
	"./content/sticky/general/221x86/pageData.json": 674,
	"./content/toaster/Business use cases/140px/pageData": 675,
	"./content/toaster/Business use cases/140px/pageData.json": 675,
	"./content/toaster/Business use cases/50px/pageData": 676,
	"./content/toaster/Business use cases/50px/pageData.json": 676,
	"./content/toaster/discounts/140px/pageData": 677,
	"./content/toaster/discounts/140px/pageData.json": 677,
	"./content/toaster/discounts/50px/pageData": 678,
	"./content/toaster/discounts/50px/pageData.json": 678,
	"./content/toaster/payment/140px/pageData": 679,
	"./content/toaster/payment/140px/pageData.json": 679,
	"./content/toaster/payment/50px/pageData": 680,
	"./content/toaster/payment/50px/pageData.json": 680,
	"./content/toaster/promotion/140px/pageData": 681,
	"./content/toaster/promotion/140px/pageData.json": 681,
	"./content/toaster/promotion/50px/pageData": 682,
	"./content/toaster/promotion/50px/pageData.json": 682,
	"./content/toaster/sales/140px/pageData": 683,
	"./content/toaster/sales/140px/pageData.json": 683,
	"./content/toaster/sales/50px/pageData": 684,
	"./content/toaster/sales/50px/pageData.json": 684,
	"./content/toaster/seasons/140px/pageData": 685,
	"./content/toaster/seasons/140px/pageData.json": 685,
	"./content/toaster/seasons/50px/pageData": 686,
	"./content/toaster/seasons/50px/pageData.json": 686,
	"./content/toaster/social/140px/pageData": 687,
	"./content/toaster/social/140px/pageData.json": 687,
	"./content/toaster/social/50px/pageData": 688,
	"./content/toaster/social/50px/pageData.json": 688,
	"./content/toaster/support_services/140px/pageData": 689,
	"./content/toaster/support_services/140px/pageData.json": 689,
	"./content/toaster/support_services/50px/pageData": 690,
	"./content/toaster/support_services/50px/pageData.json": 690,
	"./content/toaster/travel/140px/pageData": 691,
	"./content/toaster/travel/140px/pageData.json": 691,
	"./content/toaster/travel/50px/pageData": 692,
	"./content/toaster/travel/50px/pageData.json": 692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2393;